module.exports = [{"year":2016,"languages":["en","zh","ja"]},{"year":2017,"languages":["en","zh","ja","fr","es","id"]},{"year":2018,"languages":["en","zh","es"]},{"year":2019,"languages":["en","zh","es","ja"]}]


//////////////////
// WEBPACK FOOTER
// ./data/settings.json
// module id = 424
// module chunks = 230186691558513